export default {
  isSimulationExamSlidingMenuEnabled: false,
  enableSimulationExamSlidingMenu() {
    this.isSimulationExamSlidingMenuEnabled = true;
  },
  disableSimulationExamSlidingMenu() {
    this.isSimulationExamSlidingMenuEnabled = false;
  },
};
